<template>
  <div class="defaultContainer">
    <ToolBar />
    <Container />
  </div>
</template>

<script>
import Container from '@/components/Container.vue';
import ToolBar from '@/components/ToolBar.vue';

export default {
  name: 'DefaultContainer',
  components: {
    ToolBar,
    Container,
  },
};
</script>
